import createLucideIcon from '../createLucideIcon';

const Divide = createLucideIcon('DivideIcon', [
  ['circle', { cx: '12', cy: '6', r: '1', key: '1bh7o1' }],
  ['line', { x1: '5', y1: '12', x2: '19', y2: '12', key: '1smlys' }],
  ['circle', { cx: '12', cy: '18', r: '1', key: 'lqb9t5' }],
]);

export default Divide;
